export interface AdminSectionMeta {
  id: string;
  label: string;
}

interface Props {
  sections: ReadonlyArray<AdminSectionMeta>;
  active: string;
  onSelect(id: string): void;
}

export function AdminSidebar({ sections, active, onSelect }: Props) {
  return (
    <aside className="adm-sidebar" aria-label="Admin sections">
      <h3>Sections</h3>
      {sections.map((s) => (
        <a
          key={s.id}
          href={`#${s.id}`}
          className={s.id === active ? 'active' : undefined}
          onClick={(e) => {
            e.preventDefault();
            document.getElementById(s.id)?.scrollIntoView({ behavior: 'smooth' });
            if (typeof window !== 'undefined') {
              window.history.replaceState(null, '', `#${s.id}`);
            }
            onSelect(s.id);
          }}
        >
          {s.label}
        </a>
      ))}
    </aside>
  );
}
